import axios from 'axios';

export const removeReqInterceptor = (id: number | undefined) => {
  if (id === undefined) return;
  return axios.interceptors.request.eject(id);
};
export const removeResInterceptor = (id: number | undefined) => {
  if (id === undefined) return;
  return axios.interceptors.response.eject(id);
};

export const setupAuthReqInterceptor = (accessToken?: string) => {
  return axios.interceptors.request.use((config: any) => {
    if (accessToken !== undefined) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  });
};
